<template>
  <el-dialog
    v-dialogDrag
    title="详情"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="set-small-dialog"
    width="1200px"
  >
    <div>
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="课件名称"
          maxlength="50"
          v-model="searchData.name"
          clearable
        ></el-input>
        <el-date-picker
          v-model="searchData.date"
          type="daterange"
          class="mr-10px"
          size="small"
          range-separator="至"
          :start-placeholder="`${$t('开始日期')}`"
          :end-placeholder="`${$t('结束日期')}`"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-select
          v-model="searchData.status"
          size="small"
          :placeholder="`${$t('学习状态')}`"
          class="mr-10px !w-50"
          clearable
          collapse-tags
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item"
            :value="index"
          ></el-option>
        </el-select>
        <el-button size="small" @click="resetText">重置</el-button>
        <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        height="400px"
        stripe
        v-loading="equipTableLoading"
      >
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column label="姓名" prop="userName" show-overflow-tooltip></el-table-column>
        <el-table-column label="课件" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="节点" prop="nodes" show-overflow-tooltip></el-table-column>
        <el-table-column label="学习开始时间" prop="studyTimeStart" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.studyTimeStart | showText('time') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学习结束时间" prop="studyTimeEnd" show-overflow-tooltip
          ><template slot-scope="scope">
            <span>{{ scope.row.studyTimeEnd | showText('time') }}</span>
          </template></el-table-column
        >
        <el-table-column label="学习状态" prop="statusName" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="text-right mt-20px ml-10px"
      ></el-pagination>
    </div>
    <div slot="footer" class="text-center">
      <el-button size="small" @click="dialogVisible = false">{{ $t('取消') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { TrainingRecordApi } from '@wiz-api/training-management'
import utils from '@/components/safety/enumField/utils'
import dayjs from 'dayjs'

const trainingRecordApi = new TrainingRecordApi()
export default {
  name: 'record-info',
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
    trainData: {
      type: Object,
      default: () => {},
    },
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        result = val && dayjs(val).format('YYYY-MM-DD HH:mm:ss')
      }
      return result
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  data() {
    return {
      searchData: {
        date: [],
        status: '',
        name: '',
      },
      equipDataList: [],
      statusList: ['未学', '学习中', '已学'],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  mounted() {
    this.getEquipList()
  },

  methods: {
    // 重置
    resetText() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        id: this.trainData.id,
        userId: this.trainData.userId,
        ...searchData,
      }
      if (this.searchData.date?.length) {
        data.dateStart = this.searchData.date[0]
        data.dateEnd = this.searchData.date[1]
      }
      this.equipTableLoading = true
      const [err, res] = await trainingRecordApi.getDetialList(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>
<style lang="scss" scoped>
.set-small-dialog {
  .el-dialog__body {
    height: 300px;
  }
}
</style>
